import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { AddressModel } from '@data-layer/models/common';

@Component({
  selector: 'address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.scss'],
})
export class AddressDetailsComponent implements OnChanges {
  @Input() public address: AddressModel;
  @Input() public isJoinAllParts: boolean;
  @Input() public isShowPostalCode: boolean = false;

  public line1: string;
  public line2: string;
  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.address && this.address) {
      const state = this.address.state ? this.address.state.description : null;
      const stateCode = this.address.state ? this.address.state.code : null;
      const postalCode = this.address.postalCode ? this.address.postalCode : null;
      const country = this.address.country ? this.address.country.description : null;
      const address = [this.address?.line1, this.address?.line2, this.address?.line3]
        .filter((part) => !!part)
        .join(this.isJoinAllParts ? ', ' : '\n')
        .trim();
      this.line1 = [address, this.address.city]
        .filter((part) => !!part)
        .join(', ')
        .trim();
      this.line2 = (this.isShowPostalCode ? [country] : [country, state])
        .filter((part) => !!part)
        .join(', ')
        .trim();

      this.line2 += this.isShowPostalCode
        ? ', ' +
          [stateCode, postalCode]
            .filter((part) => !!part)
            .join(' ')
            .trim()
        : '';
      // #9180
      if (this.isJoinAllParts && !!this.line1 && !!this.line2) {
        this.line1 += ', ';
      }
    }
  }
}
